import * as React from 'react';
export const IcBrokenImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6 9.5c0 .83.67 1.5 1.5 1.5S9 10.33 9 9.5 8.33 8 7.5 8 6 8.67 6 9.5zM19 4h-5.4l-2.31 2h7.7c.55 0 1 .45 1 1v6.7l-3.83-3.45c-.38-.34-.96-.34-1.34 0l-2.01 1.83.54.9a1 1 0 01-.22 1.28l-2.08 1.73 2.08 1.73c.23.19.36.47.36.77 0 .3-.13.58-.36.77l-.88.73h6.74c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3H19zM8.5 16c0-.3.13-.58.36-.77l.85-.71-1.57-1.3c-.38-.31-.93-.3-1.3.02L4 15.76V7c0-.55.45-1 1-1h3.24l2.31-2H5C3.35 4 2 5.35 2 7v10c0 1.65 1.35 3 3 3h4.14l1.8-1.5-2.08-1.73A.992.992 0 018.5 16z'
      fill='currentColor'
    />
  </svg>
);
